export default {
  discount: {
    en: 'Get {discount} off your first month',
  },
  freeProduct: {
    en: 'Get your free fragrance',
  },
}
